import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        //primary: '#108B1F',
        primary: '#66BB6A',
        success: '#C0CA33',
      },
    },
  },
});
